var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcc2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "#110F14",
    stroke: "#36333C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_609_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7959 24.3954H11.1811C10.2283 24.3954 9.45312 23.6202 9.45312 22.6675V13.3119C9.45312 12.3592 10.2283 11.584 11.1811 11.584H24.7959C25.7487 11.584 26.5239 12.3592 26.5239 13.3119V22.6675C26.5239 23.6204 25.7487 24.3954 24.7959 24.3954ZM11.1811 12.722C10.8558 12.722 10.5912 12.9868 10.5912 13.3119V22.6675C10.5912 22.9927 10.8558 23.2573 11.1811 23.2573H24.7959C25.1212 23.2573 25.3858 22.9926 25.3858 22.6675V13.3119C25.3858 12.9866 25.121 12.722 24.7959 12.722H11.1811Z",
    fill: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9881 19.9669C16.9623 19.9669 15.9777 19.5322 15.2867 18.7742L9.92554 12.8917L10.7667 12.125L16.1279 18.0074C16.6106 18.537 17.2713 18.8289 17.9881 18.8289C18.7048 18.8289 19.3655 18.5372 19.8484 18.0074L25.2097 12.125L26.0508 12.8917L20.6892 18.7741C19.9984 19.5322 19.0138 19.9669 17.9881 19.9669Z",
    fill: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1717 17.8427L9.95703 23.084L10.7638 23.8867L15.9785 18.6454L15.1717 17.8427Z",
    fill: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8069 17.8438L20 18.6465L25.2147 23.8885L26.0215 23.0858L20.8069 17.8438Z",
    fill: "#F9F7FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_609_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.28,
    height: 17.28,
    fill: "white",
    transform: "translate(9.35938 9.35938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcc2);
export default __webpack_public_path__ + "static/media/icc2.535cbfe009be398f4b0d9d43b7e039cc.svg";
export { ForwardRef as ReactComponent };